export default "__VITE_ASSET__DIF1hKMW__"